<template>
  <div>
    <v-container class="grey lighten-5">
      <v-row no-gutters class="pagination-table-header">
        <v-col
          col="12"
        >
          <v-overlay
            :absolute="true"
            :value="isComponentLoading"
          >
            <v-progress-circular indeterminate size="24"></v-progress-circular>
          </v-overlay>
          <v-card
            v-if="L.isEmpty(paginatedObject) || L.isEmpty(paginatedObject.data)"
            class="pa-3">
            <p class="text-center mt-2">
              <v-icon>mdi-account-search-outline</v-icon>
              <b>&nbsp;&nbsp;{{lang($store, 'sap/listings.not_found')}}&nbsp;&nbsp;</b>
              <v-icon>mdi-account-badge-outline</v-icon>
            </p>
          </v-card>
          <div v-else>
            <template v-for="(item) in paginatedObject.data">
                <phone-row :key="item.uuid" :default="item" @deleted="$emit('delete-item')" />
            </template>

          </div>
        </v-col>
      </v-row>
    </v-container>

  </div>
</template>

<script>
import _ from 'lodash';
/* constants */
import PhoneRow from '@/components/listings/PhoneRow.vue';
import { MANAGER_TOP } from '@/constants/roles';
/* utils */
import { roles as rolesColors } from '../../utils/listingColors';
/* mixins */
import isComponentLoading from '../../mixins/isComponentLoading';

export default {
  name: 'TablePaginatedPhones',
  components: { PhoneRow },
  mixins: [isComponentLoading],
  data() {
    return {
      MANAGER_TOP,
      rolesColors,
      L: _,
    };
  },
  props: {
    paginatedObject: {
      type: Object,
      default: () => {
      },
    },
    noActions: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    account() {
      return this.$store.getters['account/account'];
    },
  },
  methods: {
    onItemEdit(item) {
      this.$emit('edit-item', item);
    },
    onItemDelete(item) {
      this.$emit('delete-item', item);
    },
  },
};
</script>

<style lang="sass" scoped>
  .table-action
    &:hover
      fill: #0066ff
      transition: fill 0.5s
      cursor: pointer
</style>
